import React, { Component } from 'react';
import { Row, Col, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import './DataDef.css';

class DataDef extends Component {
	render() {
		return (
		<div className='DataDef-content'>
			<Row className='justify-content-center px-3 pb-5'>
				<Col md={10} lg={8} xl={6}>
					<h2 className='text-center'>Data Catalogue</h2>
					<p><strong>Annual Energy Use (2017)</strong></p>
					<Table size='sm'>
						<thead>
							<th>Energy Type</th>
							<th>Source</th>
							<th>GHG Emissions Factor (2017)</th>
						</thead>
						<tbody>
							<tr>
								<td>Electricity</td><td>Toronto Hydro</td><td>32 grams CO₂e / kWh</td>
							</tr>
							<tr>
								<td>Natural Gas</td><td>Enbridge Inc.</td><td>1874.6 grams CO₂e / m³</td>
							</tr>
							<tr>
								<td>Steam (District Heat)</td><td>Enwave Energy Corporation</td><td>73.8 grams CO₂e / lb</td>
							</tr>
							<tr>
								<td>Deep Lake Water Cooling</td><td>Enwave Energy Corporation</td><td>41.3 grams CO₂e / ton-h</td>
							</tr>		
							<tr>
								<td>Water*</td><td>City of Toronto</td><td>114.4 grams CO₂e / m³</td>
							</tr>		
							<tr>
								<td colspan='3'><small>* Water GHG Emissions Factor is based on the average City of Toronto emissions for water pumping and treatment and sewage pumping and treatment.</small></td>
							</tr>								
						</tbody>
					</Table>
					<p><strong>Additional Data Sources:</strong></p>
					<ul>
						<li>Building Energy Models based on ASHRAE 90.1 (2004) - Sources: Jenn McArthur, Ryerson University; ASHRAE</li>
						<li>Commercial Buildings Energy Consumption Survey (2003): Sources: US Energy Information Administration; Bob Bach (conversion to Toronto climate zone)</li>
						<li>Transportation Models based on Transportation for Tomorrow Survey (2011)- Sources: Marianne Hatzopoulou, University of Toronto; Ontario Ministry of Transportation</li>
						<li>Energy Use and Total Floor Area for Institutional Buildings (2016) - Source: Ontario Ministry of Energy, Broader Public Sector GHG Emissions</li>
						<li>Building Age, Occupancy Type, and Total Floor Area (2017) - Source: Municipal Property Assessment Corporation</li>
						<li>Building Outlines and 3D Massing (2017) - Source: City of Toronto, Planning Division</li>
						<li>Address Points (2017)- Source: City of Toronto, Information & Technology Division</li>
					</ul>			
				<h2 className='text-center'>Definitions</h2>
				<p><strong>Building Categories:</strong></p>
				<ul>
					<li>Office - Includes small, street-level office units up to large multi-storey office towers.</li>
				<li>Retail & Hospitality - Includes all retail, restaurants, hotel, and entertainment establishments.</li>
				<li>Multi-Unit Residential - Includes all buildings with 7 or more residential units.</li>
				<li>Residential - Includes all buildings with 6 or fewer residential units.</li>
				<li>Institutional - Includes schools, post-secondary campuses, long-term care facilities, and hospitals.</li>
				<li>Industrial - Includes warehouses and manufacturing.</li>
					</ul>			
				<h2 className='text-center'>Limitations</h2>
				<p>Due to licensing restrictions, metred energy consumption data are shown only at the District level. Block-level data are modelled using information about the building size, age, and occupancy. Where information about buildings was incomplete, additional information was collected through Internet searches and Google Street View. Additional building information about institutional buildings such as the University of Toronto and Ryerson University are in the process of being integrated into the Platform.</p>
				</Col>
			</Row>
			<Row className='justify-content-center px-3 py-5 bg-light'>
				<Col  md={10} lg={8} xl={6}>
				<h2 className='text-center'><a name="disclaimer">Disclaimer</a></h2>
				<p>While the Canadian Urban Institute has used reasonable efforts to provide accurate and current information through this website, the Canadian Urban Institute, the Toronto 2030 District, and the Toronto 2030 Platform partners accept no liability for the content and makes no warranties or representations of any kind concerning the accuracy or suitability of the information contained on this website for any purpose. </p>

				<p>The information presented on this website is provided by the Canadian Urban Institute for educational and information purposes, which you may use at your own risk.</p>

				<p>This website also contains links to various third party websites.  These links are provided as a convenience and not as an endorsement of the contents of these websites.</p>

				<p>You should not rely on, or take or fail to take any action, based upon the information on this website alone without independent verification.  Readers should obtain appropriate legal and technical advice.</p>
				</Col>
			</Row>
			<Row>
				<Col sm={12} className='social text-center'>
					<a href="https://twitter.com/TO_2030District"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>{'    '}
					<a href="https://www.linkedin.com/groups/8135789"><FontAwesomeIcon icon={faLinkedinIn} size='lg' /></a>{'    '}
					<a href="https://www.facebook.com/Toronto2030District/"><FontAwesomeIcon icon={faFacebookF} size='lg' /></a>
  			</Col>	
			</Row>
			</div>
		)
	}
}

export default DataDef;


// WEBPACK FOOTER //
// ./src/DataDef.js